import React, { Component } from 'react';
import {
    Box,
    Typography,
    TextField,
    InputAdornment,
    Card,
    Chip,
    Avatar,
    IconButton,
    Paper,
    Button
} from '@mui/material';
import {
    LocationOn,
    Search,
    MyLocation,
    Tune,
    LocalOffer,
    Storefront,
    DirectionsRun,
    AddLocationAlt,
    Favorite,
    FavoriteBorder
} from '@mui/icons-material';
import { apiUrl } from '../../comp/ApiUrl';
import { WithRouter } from '../../comp/WithRouter';

class HomeHubMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userLocation: null,
            enderecoAtual: '',
            segmentoAtivo: 'todos',
            termoBusca: '',
            favoritos: [], // Array com IDs das lojas favoritadas pelo usuário

            // Stories / Lives da vitrine
            storiesLives: [
                {
                    id: 1,
                    nome: 'Pet & Cia',
                    subdominio: 'pet-cia',
                    imagem: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=150',
                    tipo: 'live',
                    segmento: 'Pet Shop'
                },
                {
                    id: 2,
                    nome: 'Pizzaria',
                    subdominio: 'pizzaria-napolitana',
                    imagem: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=150',
                    tipo: 'live',
                    segmento: 'Alimentação'
                },
                {
                    id: 3,
                    nome: 'Farmácia',
                    subdominio: 'farmacia-vida',
                    imagem: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=150',
                    tipo: 'story',
                    segmento: 'Farmácia'
                },
                {
                    id: 4,
                    nome: 'Tech Express',
                    subdominio: 'tech-celulares',
                    imagem: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=150',
                    tipo: 'story',
                    segmento: 'Eletrônicos'
                }
            ],

            // Dados dinâmicos consumidos da API
            segmentos: [],
            lojasProximas: []
        };
    }

    componentDidMount() {
        this.carregarDadosHub();
    }

    carregarDadosHub = () => {
        fetch(`api/hub/data`, {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((data) => {
                let textoEndereco = '';
                if (data.user_location) {
                    if (typeof data.user_location === 'string') {
                        textoEndereco = data.user_location;
                    } else if (data.user_location.rua || data.user_location.bairro) {
                        textoEndereco = `${data.user_location.rua ? data.user_location.rua + ', ' : ''}${data.user_location.bairro || ''}`;
                    } else if (data.user_location.lat && data.user_location.lng) {
                        textoEndereco = `Lat: ${parseFloat(data.user_location.lat).toFixed(3)}, Lng: ${parseFloat(data.user_location.lng).toFixed(3)}`;
                    }
                }

                this.setState({
                    userLocation: data.user_location || null,
                    enderecoAtual: textoEndereco,
                    lojasProximas: data.stores || [],
                    segmentos: data.segmentos || []
                });
            })
            .catch((err) => console.error('Erro ao carregar dados do hub:', err));
    };

    // Alternar status de favorita de uma loja
    toggleFavorito = (e, storeId) => {
        e.stopPropagation(); // Evita abrir a loja ao clicar no coração
        this.setState((prevState) => {
            const jaFavoritou = prevState.favoritos.includes(storeId);
            const novosFavoritos = jaFavoritou
                ? prevState.favoritos.filter((id) => id !== storeId)
                : [...prevState.favoritos, storeId];

            return { favoritos: novosFavoritos };
        });
    };

    // Navegação para a página específica da loja pelo ID (ex: /loja/1)
    abrirLoja = (storeId) => {
        if (storeId) {
            this.props.navigate(`/loja/${storeId}`);
        }
    };

    // Redireciona o usuário para cadastrar/selecionar um endereço
    abrirSelecaoEndereco = () => {
        this.props.navigate('/enderecos');
    };

    // Navegação para Live / Story
    abrirLive = (item) => {
        this.props.navigate(`/live/${item.id}`);
    };

    abrirStory = (item) => {
        this.props.navigate(`/story`);
    };

    // Helper para extrair o nome do segmento pelo ID
    obterNomeSegmento = (segmentId) => {
        if (!segmentId) return 'Diversos';
        const seg = this.state.segmentos.find((s) => String(s.id) === String(segmentId));
        return seg ? seg.name : 'Diversos';
    };

    // Helper para formatar o endereço completo da loja
    formatarEnderecoLoja = (loja) => {
        const partes = [];
        if (loja.rua) partes.push(loja.rua);
        if (loja.numero) partes.push(loja.numero);
        if (loja.bairro) partes.push(loja.bairro);
        if (loja.cidade) partes.push(loja.estado ? `${loja.cidade} - ${loja.estado}` : loja.cidade);

        return partes.length > 0 ? partes.join(', ') : 'Endereço não informado';
    };

    render() {
        const {
            userLocation,
            enderecoAtual,
            segmentos,
            segmentoAtivo,
            storiesLives,
            lojasProximas,
            termoBusca,
            favoritos
        } = this.state;

        // Filtragem combinada por Segmento e Busca por texto (nome, bairro ou cidade)
        const lojasFiltradas = lojasProximas.filter((loja) => {
            const atendeSegmento =
                segmentoAtivo === 'todos' || String(loja.store_segment) === String(segmentoAtivo);
            const termo = termoBusca.toLowerCase().trim();
            const atendeBusca =
                !termo ||
                (loja.store_name && loja.store_name.toLowerCase().includes(termo)) ||
                (loja.bairro && loja.bairro.toLowerCase().includes(termo)) ||
                (loja.cidade && loja.cidade.toLowerCase().includes(termo)) ||
                (loja.rua && loja.rua.toLowerCase().includes(termo));

            return atendeSegmento && atendeBusca;
        });

        return (
            <Box
                sx={{
                    bgcolor: '#f8f9fa',
                    minHeight: '100vh',
                    pb: 10,
                    maxWidth: '480px',
                    mx: 'auto',
                    position: 'relative',
                    boxShadow: '0 0 20px rgba(0,0,0,0.05)'
                }}
            >
                {/* BARRA SUPERIOR FIXA */}
                <Box
                    sx={{
                        bgcolor: '#562dab',
                        color: '#fff',
                        px: 2,
                        pt: 2,
                        pb: 2.5,
                        borderBottomLeftRadius: '24px',
                        borderBottomRightRadius: '24px'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justify: 'space-between',
                            alignItems: 'center',
                            mb: 2
                        }}
                    >
                        <Box sx={{ flexGrow: 1, pr: 1 }}>
                            <Typography
                                variant="caption"
                                sx={{
                                    color: 'rgba(255,255,255,0.7)',
                                    display: 'block',
                                    fontSize: '10px',
                                    fontWeight: 700,
                                    letterSpacing: '0.5px'
                                }}
                            >
                                SEU ENDEREÇO DE ENTREGA
                            </Typography>

                            {/* VERIFICAÇÃO DE ENDEREÇO DO USUÁRIO */}
                            {userLocation && enderecoAtual ? (
                                <Box
                                    onClick={this.abrirSelecaoEndereco}
                                    sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', mt: 0.3 }}
                                >
                                    <LocationOn sx={{ color: '#ffb142', fontSize: 18, mr: 0.5 }} />
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: 700,
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            maxWidth: '240px'
                                        }}
                                    >
                                        {enderecoAtual}
                                    </Typography>
                                </Box>
                            ) : (
                                <Button
                                    size="small"
                                    onClick={this.abrirSelecaoEndereco}
                                    startIcon={<AddLocationAlt sx={{ color: '#ffb142' }} />}
                                    sx={{
                                        color: '#fff',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                        fontSize: '12px',
                                        p: 0,
                                        minWidth: 'auto',
                                        mt: 0.3,
                                        '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' }
                                    }}
                                >
                                    Cadastrar / Selecionar Endereço
                                </Button>
                            )}
                        </Box>

                        <IconButton
                            size="small"
                            onClick={this.carregarDadosHub}
                            sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: '#fff', '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' } }}
                        >
                            <MyLocation fontSize="small" />
                        </IconButton>
                    </Box>

                    {/* CAMPO DE BUSCA */}
                    <TextField
                        fullWidth
                        size="small"
                        value={termoBusca}
                        onChange={(e) => this.setState({ termoBusca: e.target.value })}
                        placeholder="Buscar lojas, roupas, serviços ou bairros..."
                        variant="outlined"
                        sx={{
                            bgcolor: '#fff',
                            borderRadius: '14px',
                            '& .MuiOutlinedInput-root': { borderRadius: '14px', fontSize: '13px' },
                            '& fieldset': { border: 'none' }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search sx={{ color: '#562dab' }} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton size="small">
                                        <Tune sx={{ fontSize: 18, color: '#562dab' }} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Box>

                {/* CONTEÚDO PRINCIPAL */}
                <Box sx={{ px: 2, mt: 2 }}>
                    {/* STORIES E LIVES DA VITRINE */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1.5,
                            overflowX: 'auto',
                            pb: 1,
                            mb: 2.5,
                            '&::-webkit-scrollbar': { display: 'none' }
                        }}
                    >
                        {storiesLives.map((item) => (
                            <Box
                                key={item.id}
                                onClick={() => (item.tipo === 'live' ? this.abrirLive(item) : this.abrirStory(item))}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    minWidth: '68px'
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 64,
                                        height: 64,
                                        borderRadius: '50%',
                                        padding: '2px',
                                        background:
                                            item.tipo === 'live'
                                                ? 'linear-gradient(45deg, #ff4757, #ff6b81)'
                                                : 'linear-gradient(45deg, #562dab, #845ec2)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative'
                                    }}
                                >
                                    <Avatar
                                        src={item.imagem}
                                        sx={{ width: 58, height: 58, border: '2px solid #fff' }}
                                    />
                                    {item.tipo === 'live' ? (
                                        <Chip
                                            label="LIVE"
                                            size="small"
                                            sx={{
                                                position: 'absolute',
                                                bottom: -5,
                                                bgcolor: '#ff4757',
                                                color: '#fff',
                                                fontSize: '8px',
                                                fontWeight: 900,
                                                height: '15px',
                                                px: 0.5
                                            }}
                                        />
                                    ) : (
                                        <Chip
                                            label={item.segmento}
                                            size="small"
                                            sx={{
                                                position: 'absolute',
                                                bottom: -5,
                                                bgcolor: '#562dab',
                                                color: '#fff',
                                                fontSize: '8px',
                                                fontWeight: 700,
                                                height: '15px'
                                            }}
                                        />
                                    )}
                                </Box>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        mt: 1,
                                        fontWeight: 600,
                                        color: '#2f3542',
                                        textAlign: 'center',
                                        fontSize: '11px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {item.nome}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    {/* BANNER PROMOCIONAL */}
                    <Paper
                        elevation={0}
                        sx={{
                            background: 'linear-gradient(135deg, #562dab 0%, #7b42f6 100%)',
                            color: '#fff',
                            p: 2,
                            borderRadius: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mb: 3,
                            boxShadow: '0 8px 20px rgba(86, 45, 171, 0.2)'
                        }}
                    >
                        <Box>
                            <Chip
                                label="ENTREGA NA SUA REGIÃO"
                                size="small"
                                sx={{
                                    bgcolor: 'rgba(255,255,255,0.2)',
                                    color: '#fff',
                                    fontWeight: 800,
                                    fontSize: '9px',
                                    mb: 0.5
                                }}
                            />
                            <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                                Os melhores comércios locais
                            </Typography>
                            <Typography variant="caption" sx={{ opacity: 0.9, fontSize: '11px' }}>
                                Roupas, eletrônicos, serviços e alimentação no seu bairro.
                            </Typography>
                        </Box>
                        <LocalOffer sx={{ fontSize: 36, opacity: 0.8 }} />
                    </Paper>

                    {/* CATEGORIAS / SEGMENTOS */}
                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#2f3542', mb: 1 }}>
                        Categorias
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            overflowX: 'auto',
                            pb: 1,
                            mb: 3,
                            '&::-webkit-scrollbar': { display: 'none' }
                        }}
                    >
                        {/* OPÇÃO TODOS */}
                        <Paper
                            elevation={0}
                            onClick={() => this.setState({ segmentoAtivo: 'todos' })}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                px: 2,
                                py: 0.8,
                                borderRadius: '20px',
                                cursor: 'pointer',
                                bgcolor: segmentoAtivo === 'todos' ? '#562dab' : '#fff',
                                color: segmentoAtivo === 'todos' ? '#fff' : '#57606f',
                                border: '1px solid',
                                borderColor: segmentoAtivo === 'todos' ? '#562dab' : '#e0e0e0',
                                whiteSpace: 'nowrap',
                                fontWeight: 700,
                                fontSize: '12px',
                                transition: 'all 0.2s'
                            }}
                        >
                            Todos
                        </Paper>

                        {/* LISTAGEM DINÂMICA DA API */}
                        {segmentos.map((seg) => (
                            <Paper
                                key={seg.id}
                                elevation={0}
                                onClick={() => this.setState({ segmentoAtivo: seg.id })}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    px: 2,
                                    py: 0.8,
                                    borderRadius: '20px',
                                    cursor: 'pointer',
                                    bgcolor: segmentoAtivo === seg.id ? '#562dab' : '#fff',
                                    color: segmentoAtivo === seg.id ? '#fff' : '#57606f',
                                    border: '1px solid',
                                    borderColor: segmentoAtivo === seg.id ? '#562dab' : '#e0e0e0',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 700,
                                    fontSize: '12px',
                                    transition: 'all 0.2s'
                                }}
                            >
                                {seg.name}
                            </Paper>
                        ))}
                    </Box>

                    {/* FEED DE LOJAS */}
                    <Box sx={{ mb: 4 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#2f3542' }}>
                                Estabelecimentos Próximos
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#747d8c', fontWeight: 600 }}>
                                {lojasFiltradas.length} encontrados
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                            {lojasFiltradas.length === 0 ? (
                                <Paper
                                    elevation={0}
                                    sx={{ p: 4, textAlign: 'center', bgcolor: '#fff', borderRadius: '16px', border: '1px dashed #ced6e0' }}
                                >
                                    <Storefront sx={{ fontSize: 40, color: '#a4b0be', mb: 1 }} />
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#57606f' }}>
                                        Nenhuma loja encontrada
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#a4b0be' }}>
                                        Tente selecionar outra categoria ou remover os filtros de busca.
                                    </Typography>
                                </Paper>
                            ) : (
                                lojasFiltradas.map((loja) => {
                                    const nomeSegmento = this.obterNomeSegmento(loja.store_segment);
                                    const distKm = parseFloat(loja.distance_km || 0).toFixed(1);
                                    const enderecoLoja = this.formatarEnderecoLoja(loja);
                                    const isLojaAberta = loja.isOpen !== 0 && loja.isOpen !== '0';
                                    const isFavorito = favoritos.includes(loja.id);

                                    return (
                                        <Card
                                            key={loja.id}
                                            elevation={0}
                                            onClick={() => this.abrirLoja(loja.id)}
                                            sx={{
                                                borderRadius: '16px',
                                                border: '1px solid #f1f2f6',
                                                bgcolor: '#fff',
                                                display: 'flex',
                                                p: 1.5,
                                                cursor: 'pointer',
                                                alignItems: 'center',
                                                position: 'relative',
                                                transition: 'all 0.2s',
                                                '&:active': { transform: 'scale(0.98)', bgcolor: '#fafafa' }
                                            }}
                                        >
                                            {/* FOTO DA LOJA COM OVERLAY QUANDO FECHADA */}
                                            <Box sx={{ position: 'relative', mr: 2 }}>
                                                <Avatar
                                                    src={loja.store_image ? `${apiUrl}/store/photo/${loja.store_image}` : null}
                                                    variant="rounded"
                                                    sx={{
                                                        width: 64,
                                                        height: 64,
                                                        borderRadius: '14px',
                                                        bgcolor: '#562dab',
                                                        fontWeight: 800,
                                                        fontSize: '20px',
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                                        filter: !isLojaAberta ? 'grayscale(0.8) opacity(0.7)' : 'none'
                                                    }}
                                                >
                                                    {loja.store_name ? loja.store_name.charAt(0).toUpperCase() : 'L'}
                                                </Avatar>
                                                {!isLojaAberta && (
                                                    <Box
                                                        sx={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            bgcolor: 'rgba(0, 0, 0, 0.4)',
                                                            borderRadius: '14px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: '#fff',
                                                                fontSize: '9px',
                                                                fontWeight: 900,
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.5px'
                                                            }}
                                                        >
                                                            Fechada
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>

                                            <Box sx={{ flexGrow: 1, overflow: 'hidden', pr: 4 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        sx={{
                                                            fontWeight: 800,
                                                            color: '#2f3542',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            maxWidth: '180px'
                                                        }}
                                                    >
                                                        {loja.store_name}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mt: 0.5, flexWrap: 'wrap' }}>
                                                    <Chip
                                                        label={nomeSegmento}
                                                        size="small"
                                                        sx={{
                                                            bgcolor: '#f1f2f6',
                                                            color: '#57606f',
                                                            fontSize: '10px',
                                                            fontWeight: 700,
                                                            height: '18px'
                                                        }}
                                                    />

                                                    <Chip
                                                        label={isLojaAberta ? 'Aberto' : 'Fechado'}
                                                        size="small"
                                                        sx={{
                                                            bgcolor: isLojaAberta ? '#e1f5fe' : '#ffebee',
                                                            color: isLojaAberta ? '#0288d1' : '#d32f2f',
                                                            fontSize: '9px',
                                                            fontWeight: 800,
                                                            height: '18px'
                                                        }}
                                                    />

                                                    <Typography variant="caption" sx={{ color: '#a4b0be' }}>
                                                        •
                                                    </Typography>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            color: '#2f3542',
                                                            fontWeight: 600,
                                                            fontSize: '11px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        <DirectionsRun sx={{ fontSize: 13, mr: 0.2, color: '#562dab' }} />
                                                        {distKm} km
                                                    </Typography>
                                                </Box>

                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: '#a4b0be',
                                                        display: 'block',
                                                        mt: 0.5,
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        fontSize: '11px'
                                                    }}
                                                >
                                                    {enderecoLoja}
                                                </Typography>
                                            </Box>

                                            {/* BOTÃO DE FAVORITAR (CORAÇÃO) */}
                                            <IconButton
                                                size="small"
                                                onClick={(e) => this.toggleFavorito(e, loja.id)}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    right: 8,
                                                    color: isFavorito ? '#ff4757' : '#a4b0be',
                                                    bgcolor: 'rgba(241, 242, 246, 0.6)',
                                                    '&:hover': { bgcolor: 'rgba(241, 242, 246, 1)' }
                                                }}
                                            >
                                                {isFavorito ? (
                                                    <Favorite sx={{ fontSize: 18 }} />
                                                ) : (
                                                    <FavoriteBorder sx={{ fontSize: 18 }} />
                                                )}
                                            </IconButton>
                                        </Card>
                                    );
                                })
                            )}
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default WithRouter(HomeHubMobile);